import { Todo } from "../models/Todo";
import TodoItem from "./TodoItem";
import { Reorder, useDragControls } from "framer-motion";

interface ITodoList {
  todos: Todo[];
  setTodos: React.Dispatch<React.SetStateAction<Todo[]>>;
  updateTodo(todo: Todo): void;
  removeTodo(todo: Todo): void;
}

function TodoList(props: ITodoList) {
  const dragControls = useDragControls();

  return (
    <Reorder.Group axis="y" values={props.todos} onReorder={props.setTodos}>
      {props.todos.map((todo) => (
        <Reorder.Item key={todo.id} value={todo} dragControls={dragControls}>
          <TodoItem
            key={todo.id}
            todo={todo}
            updateTodo={props.updateTodo}
            removeTodo={props.removeTodo}
          />
        </Reorder.Item>
      ))}
    </Reorder.Group>
  );
}

export default TodoList;
